import styled from '@emotion/styled';
import { ButtonBase, ButtonBaseProps } from '@mui/material';

import color from '@/styles/mobile/color';

type Props = ButtonBaseProps & {
  func?: 'primary' | 'close';
};

const MainButton = styled(ButtonBase)<Props>`
  border-radius: 2vw;
  background-color: ${(props) =>
    props.func === 'close' ? color.ui.buttonClose : color.ui.buttonPrimary};
  color: ${color.ui.textLight};
  border: none;
  font-size: 5.4vw;
  width: 100%;
  height: 12.2vw;
  line-height: 12.2vw;
  @media (orientation: landscape) {
    border-radius: 1vw;
    font-size: 2.5vw;
    height: 5.8vw;
    line-height: 5.8vw;
  }
  &:active {
    background-color: ${(props) =>
      props.func === 'close'
        ? color.ui.buttonCloseHover
        : color.ui.buttonPrimaryHover};
  }
`;

export default MainButton;
